import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=c013a920&scoped=true&"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
import style0 from "./CopyToClipboard.vue?vue&type=style&index=0&id=c013a920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c013a920",
  null
  
)

export default component.exports